import { useEffect, useState } from "react";
import Layout from "./components/Layout";
import Hero from "./components/Hero";
import Programs from "./components/Programs";
import Blogs from "./components/Blogs";
import Gallery from "./components/Gallery";
import About from "./components/About";
import BlogsPage from "./components/BlogsPage";
import Contact from "./components/Contact";
import Journey from "./components/Journey";
import GalleryPreview from "./components/GalleryPreview";

function Home() {
  return (
    <>
      <Hero />
      <Programs />
      <Blogs />
      <GalleryPreview />
    </>
  );
}

export default function App() {
  const [path, setPath] = useState(window.location.pathname.toLowerCase());

  useEffect(() => {
    const onPop = () => setPath(window.location.pathname.toLowerCase());
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  let page = <Home />;
  if (path === "/gallery") page = <Gallery />;
  if (path === "/about") page = <About />;
  if (path === "/blogs") page = <BlogsPage />;
  if (path === "/contact") page = <Contact />;
  if (path === "/journey") page = <Journey />;
  return <Layout>{page}</Layout>;
}
